import React from 'react';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';
import { useNavigate } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';

function Client() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/clients-overview`);
  const navigate = useNavigate();
  
  const handleSliceClick = (status) => {
  

    const path = '/client-management/clients';    
  navigate(path , {state: { status : status } });
};
  return (
    <div className="col-span-2 bg-gradient-to-r from-white to-gray-50 h-[22vh]  w-full p-4 rounded-2xl shadow-lg  flex flex-col justify-between">
    <div className="flex justify-between items-center">
        <h3 className="text-gray-700 text-sm font-semibold">Clients Overview</h3>
        <div className="bg-gray-100 text-gray-500 p-2 rounded-full shadow-sm">
          <svg
            width="20"
            height="20"
            viewBox="0 0 42 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="vuesax/linear/profile-2user">
              <g id="profile-2user">
                <path
                  d="M16.0302 19.0229C15.8552 19.0054 15.6452 19.0054 15.4527 19.0229C11.2877 18.8829 7.98022 15.4704 7.98022 11.2704C7.98022 6.98287 11.4452 3.50037 15.7502 3.50037C20.0377 3.50037 23.5202 6.98287 23.5202 11.2704C23.5027 15.4704 20.1952 18.8829 16.0302 19.0229Z"
                  stroke="#000000"
                  strokeWidth="2.625"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28.7171 6.99963C32.1121 6.99963 34.8421 9.74713 34.8421 13.1246C34.8421 16.4321 32.2171 19.1271 28.9446 19.2496C28.8046 19.2321 28.6471 19.2321 28.4896 19.2496"
                  stroke="#000000"
                  strokeWidth="2.625"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.2805 25.4796C3.0455 28.3146 3.0455 32.9346 7.2805 35.7521C12.093 38.9721 19.9855 38.9721 24.798 35.7521C29.033 32.9171 29.033 28.2971 24.798 25.4796C20.003 22.2771 12.1105 22.2771 7.2805 25.4796Z"
                  stroke="#000000"
                  strokeWidth="2.625"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M32.0947 35.0004C33.3547 34.7379 34.5447 34.2304 35.5247 33.4779C38.2547 31.4304 38.2547 28.0529 35.5247 26.0054C34.5622 25.2704 33.3897 24.7804 32.1472 24.5004"
                  stroke="#000000"
                  strokeWidth="2.625"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>

       <div>
        <p className="text-xl font-bold text-gray-800">{data?.total}</p>
        {/* <p className="text-xs text-gray-500">Total Clients</p> */}
      </div>

        <div className="flex justify-between mt-2 text-xs font-medium">
        <span
  className="text-green-600 bg-green-100 cursor-pointer px-2 py-1 rounded-lg"
  onClick={GetAccess('clients_view') ? () => handleSliceClick('Active') : undefined}
>
  Active: {data?.active}
</span>

<span
  className="text-red-600 bg-red-100 cursor-pointer px-2 py-1 rounded-lg"
  onClick={GetAccess('clients_view') ? () => handleSliceClick('In-Active') : undefined}
>
  In-Active: {data?.inactive}
</span>
    </div>
    </div>
  );
}

export default Client;
